
import React from "react";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import { SVGAsset } from "res";
import TransactionDetailsView from "./components/TransactionDetailsView";

import "./styles.css";
import ControlView from "components/shared/views/BaseRowView/components/ControlView";
import { Branding, DisabledPrompt, Link, useParams, StateManager, useModel, useRoute, useStateManager } from '@bcm-dev/bcms-vite';
import { Transaction, Util } from "model";

/**
 * @function TransactionDetailsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TransactionDetailsPage
 * @example
 * <TransactionDetailsPage />
 */
export default function TransactionDetailsPage(props) {
  const model = useModel();
  const transactionID = useParams().transactionID ?? Util.getDefaultTransactionID(model);
  const data = { ...getDefaultData(transactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

return (
  <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
  </StateManager>
);
}

export const getDefaultData = transactionID => {
  const transactions = Transaction.initAll();
  const transaction = transactions.filter((_transaction) => {
    return _transaction.id === transactionID;
  })[0];

  return {
      transaction,
      transactionID,
      transactions
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui } = useStateManager();
  
  const cardID = data.transaction.card.id;
  const hasDispute = data.transaction.transactionDispute ? true : false;
  const disputeTransaction = data.transaction.disputeTransaction;
  const disputeTransactionDescription = hasDispute ? data.transaction.transactionDispute.type.description : "";
  const cardType = data.transaction.card.type;
  const navigate = useRoute();

  const disputeTransactionRoute = evt => {
    if(hasDispute) {
      navigate(`/home/reviewingDispute/${cardID}/${data.transactionID}`);
    } else {
      navigate(`/home/disputetransaction/${cardID}/${data.transactionID}`);
    }
  };

  return (
    <MainContentContainer className="transaction-details-page" header={<MainContentHeader text="Transaction Details" />}>
      <TransactionDetailsView transaction={ data.transaction } />

      <MainContentSection text={<div className="flex-container">
            <p className="flex-width biller-details">{ data.transaction.merchant.name }</p>
            <div className="flex-width">
              <DisabledPrompt>
                <Link className="flex-width text-right" dataPoint="Transaction_Details_Show_More">
                  <p>Show More</p>
                </Link>
              </DisabledPrompt>
            </div>
          </div>}>
          <div className="flex-container memo-tag-group">
            <div className="flex-container flex-width align-center-container memo-group">
              <SVGAsset id="NotebookPencilIcon" className="set-width left-inline-icon" />
              <p className="sub-text flex-width" data-point="Transaction_Details_Memo"><span>Add a memo...</span></p>
            </div>
            <DisabledPrompt>
              <p className="flex-container set-width sub-text tag-group clickable">
                <div className="tag" data-point="Transaction_Details_Tag">Tag</div>
                <div>&hellip;</div>
              </p>
            </DisabledPrompt>
          </div>
          <Branding id="dispute_transaction_chw23"  exp={val => val === "true"}>
            <Branding id="credit_select_chw23"  exp={val => val === "true"}>
              { cardType === "credit" && 
              <ControlView leftIcon="FlagIcon"
              controlText="Dispute Transaction"
              controlSubText={ disputeTransactionDescription }
              onClick={ disputeTransactionRoute }
              dataPoint="Transaction_Details_Dispute_Transaction"
              className="dispute-transaction-row" />
              }
            </Branding>
            <Branding id="dispute_debit_chw23"  exp={val => val === "true"}>
              { cardType === "debit" && 
              <ControlView leftIcon="FlagIcon"
              controlText="Dispute Transaction"
              controlSubText={ disputeTransactionDescription }
              onClick={ disputeTransactionRoute }
              dataPoint="Transaction_Details_Dispute_Transaction"
              className="dispute-transaction-row" />
              }
            </Branding>
          </Branding>
          
      </MainContentSection>
    </MainContentContainer>
  );
}